import { IconButton as BaseIconButton } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Container = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.biarri.primary.midnight,
  boxShadow: theme.custom.shadows.default,
  borderRadius: 4,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: theme.spacing(4),
  pointerEvents: "all",
  "& .mapboxgl-ctrl-geocoder": {
    borderRadius: 5,
    border: `2px solid ${theme.palette.biarri.primary.midnight}`,
  },
  "& .mapboxgl-ctrl-geocoder--input, .MuiOutlinedInput-notchedOutline": {
    border: "none",
    height: 28,
    fontFamily: theme.typography.fontFamily,
    padding: theme.spacing(0.5),
    marginLeft: theme.spacing(1),
    "&:focus": {
      outline: "none",
    },
  },
  "& .mapboxgl-ctrl-geocoder--icon-search": {
    display: "none",
  },
  "& .mapboxgl-ctrl-geocoder--icon-loading": {
    marginTop: "-6px",
  },
  "& .mapboxgl-ctrl-geocoder--icon-close": {
    marginTop: 0,
  },
}));

export const IconButton = styled(BaseIconButton)(({ theme }) => ({
  margin: 2,
  padding: 2,
  color: theme.palette.grey.A100,
  "&:hover": {
    color: theme.palette.common.white,
  },
}));
